import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router/index.js";
import applicationModule from "./modules/applicationModule";
import dashboardModule from "./modules/dashboardModule";
import userModule from "./modules/userModule";
import siteModule from "./modules/wizardModule";

Vue.use(Vuex);
Vue.use(router);

export default new Vuex.Store({
  state: {
    user: {
      codes: [],
      email: null,
      name: null,
      userId: null,
      sites: [],
      usingCode: null
    },
    siteActive: {
      contract: {
        is_trial: 0
      },
      segment: {
        segment: []
      }
    },
    application: {},
    post: {
      blockPost: false,
      socialMediaPosts: []
    },
    mediaManager: {
      loaded: false,
      medias: []
    },
    wizard: {
      layout: {
        layoutPreview: false,
        iframeMode: "desktop",
        layoutList: []
      },
      step: 0,
      loading: false,
      finishing: false,
      listToHighlight: [],
      bottomButtons: {
        showBottomButtons: true,
        showSkip: false,
        blockNext: false
      },
      components: [
        {
          step: "StepWizardIntegrations",
          title: "Integrações",
          dirt: false
        },
        {
          step: "StepWizardSegments",
          title: "Área de atuação",
          dirt: false
        },
        {
          step: "StepWizardWhatsapp",
          title: "Telefone",
          dirt: false
        },
        {
          step: "StepWizardCommercialName",
          title: "Nome do site",
          dirt: false
        },
        {
          step: "StepWizardAbout",
          title: "Sobre",
          dirt: false
        },
        {
          step: "StepWizardBlog",
          title: "Novidades",
          dirt: false
        },
        {
          step: "StepWizardContact",
          title: "Contato",
          dirt: false
        },
        {
          step: "StepWizardHighlight",
          title: "Destaque da Home",
          dirt: false
        },
        {
          step: "StepWizardSloganHome",
          title: "Frase da Home",
          dirt: false
        },
        {
          step: "StepWizardTestimony",
          title: "Depoimentos",
          dirt: false
        },
        {
          step: "StepWizardThemes",
          title: "Escolha um tema para começar",
          dirt: false
        },
        {
          step: "StepWizardLogoConfig",
          title: "Logo no site",
          dirt: false
        }
      ],
      segments: [],
      subsegments: [],
      segmentSlogans: [
        {
          id: 1,
          text: "Digite aqui ou escolha uma sugestão"
        },
        {
          id: 2,
          text: ""
        }
      ],
      dataSite: {
        layout: {
          id: null,
          url: "",
          thumbnail: ""
        },
        createTime: {
          startTime: null,
          finishTime: null
        },
        siteId: null,
        siteName: "",
        siteUrl: "",
        segment: "",
        selectedSubsegments: [],
        posts: [],
        novidades: [],
        servicos: [],
        portfolio: [],
        createdItems: [],
        testimonies: [],
        whatsappIdd: 30,
        whatsappNumber: "",
        template: 10,
        customSchema: {},
        themeMode: "light",
        profilePicture: "",
        logoSelected: {
          id: 2,
          use_file: null,
          show_name: 1,
          box_style: null,
          image_style: null,
          text_style: null
        },
        listLogo: [],
        avatarPicture: "",
        logoPicture: "",
        aboutSetup: {
          images: [],
          style: null,
          aboutList: [],
          selected: {
            content: null,
            id: null
          }
        },
        contactSetup: {
          images: [],
          showWhatsapp: false,
          showMap: false,
          showTelephone: true
        },
        cities: [],
        allImages: [],
        highlights: [],
        slogan: null
      }
    },
    contact: {
      tel: null,
      email: null
    }
  },
  mutations: {
    UPDATE_SEGMENTS(state, payload) {
      state.wizard.segments = payload;
    },
    RESET_SELECTED_POSTS(state, payload) {
      state.post.socialMediaPosts.forEach(post => {
        if (post.save_media == true) {
          post.save_media = false;
        }
      });
    },
    POPULATE_SOCIAL_MEDIA_POSTS(state, payload) {
      state.post.socialMediaPosts = [];
      state.post.socialMediaPosts = payload;
    },
    ADD_SOCIAL_MEDIA_POSTS(state, payload) {
      payload.forEach(post => {
        state.post.socialMediaPosts.push(post);
      });
      // state.post.socialMediaPosts.push(payload);
    },
    ADD_NEW_CATEGORY(state, payload) {
      state.siteActive.categories.push(payload);
    },
    REMOVE_CATEGORY(state, payload) {
      state.siteActive.categories.splice(payload, 1);
    },
    UPDATE_TEMPLATEID(state, payload) {
      state.siteActive.template = payload;
    },
    UPDATE_DISCOUNT_CODE(state, payload) {
      state.user.usingCode = payload;
    },
    BLOCK_POST(state, payload) {
      state.post.blockPost = payload;
    },
    UPDATE_APPLICATION(state, payload) {
      state.application = payload;
      document.title = state.application.app_name + " - Painel";
      let body = document.body;
      if (state.application.class == "uli") {
        body.classList.add(state.application.class);
      } else {
        body.classList.add("others");
      }
    },
    UPDATE_USER(state, payload) {
      state.user = { ...state.user, ...payload };
    },
    UPDATE_SITE_ACTIVE(state, payload) {
      state.siteActive = payload;
      window.localStorage.setItem("statusContract", payload.contract.status);
      if (
        state.siteActive.status == 0 &&
        router.history.current.name != "PaymentAlert" &&
        router.history.current.name != "Checkout"
      ) {
        router.push({
          name: "PaymentAlert"
        });
      }
    },
    UPDATE_FAVICON(state, payload) {
      document.head ||
        (document.head = document.getElementsByTagName("head")[0]);
      var link = document.createElement("link"),
        oldLink = document.getElementById("dynamicFavicon"),
        src = payload.favicon + "?=" + Math.random();
      link.id = "dynamicFavicon";
      link.rel = "icon";
      link.href = src;
      if (oldLink) {
        document.head.removeChild(oldLink);
      }
      document.head.appendChild(link);
    },
    UPDATE_APPLETOUCH(state, payload) {
      document.head ||
        (document.head = document.getElementsByTagName("head")[0]);
      var appleIcon = document.createElement("link"),
        oldIcon = document.getElementById("appleTouchIcon"),
        src = payload;
      appleIcon.id = "appleTouchIcon";
      appleIcon.rel = "apple-touch-icon";
      appleIcon.href = src;
      if (oldIcon) {
        document.head.removeChild(oldIcon);
      }
      document.head.appendChild(appleIcon);
    },
    UPDATE_FILE_SITEACTIVE(state, payload) {
      this.imageUrl = payload.filePath;
      this.image = "";
      var that;
      var highResImage = new Image();
      that = this;
      highResImage.onload = function() {
        that.image = that.imageUrl;
      };
      state.siteActive[payload.type] = this.imageUrl;
    },
    UPDATE_LOGO(state, payload) {
      this.imageUrl = payload;
      this.image = "";
      var that;
      var highResImage = new Image();
      that = this;
      highResImage.onload = function() {
        that.image = that.imageUrl;
      };
      state.siteActive.logo = this.imageUrl;
    },
    UPDATE_STEP(state, payload) {
      state.wizard.step = payload;
      if (state.wizard.step == 1) {
        const token = localStorage.getItem("jwt");
        const siteId = localStorage.siteId;
        axios({
          method: "get",
          url: `${process.env.ROOT_API}/api/site/${siteId}/wizard?savemedia=true`,
          data: "",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
      } else if (state.wizard.step == 4) {
        state.wizard.loading = true;
        const token = localStorage.getItem("jwt");
        const siteId = localStorage.siteId;
        axios({
          method: "get",
          url: `${process.env.ROOT_API}/api/site/${siteId}/wizard/cards`,
          data: "",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }).then(response => {
          this.commit("POPULATE_POSTS", response.data.cards);
          this.commit("POPULATE_ALL_IMAGES", response.data.allImages);
          this.commit("COMPONENT_SAVE_MEDIA_MANAGER", response.data.allImages);
          state.wizard.loading = false;
        });

        return true;
      }
    },
    SEND_WIZARD(state) {
      state.wizard.bottomButtons.blockNext = true;
      state.wizard.finishing = true;
      let token = localStorage.getItem("jwt");
      let siteId = localStorage.siteId;
      axios({
        method: "post",
        url: `${process.env.ROOT_API}/api/site/${siteId}/wizard/update`,
        data: {
          wizard: state.wizard.dataSite,
          components: state.wizard.components
        },
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(response => {
          localStorage.setItem("wizardFinish", true);
          const endDate = new Date();
          this.commit("WIZARD_SAVE_END_DATE", endDate);
          setTimeout(() => {
            window.location.replace(response.data.url);
          }, 5000);
          //this.commit("WIZARD_UPDATE_LIST_LOGOS", response.data.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    POPULATE_LAYOUTS(state, payload) {
      state.wizard.layout.layoutList = payload;
    },
    UPDATE_WHATSAPP_NUMBER(state, payload) {
      state.wizard.dataSite.whatsappNumber = payload;
    },
    UPDATE_WHATSAPP_IDD(state, payload) {
      state.wizard.dataSite.whatsappIdd = payload;
    },
    UPDATE_CITY(state, payload) {
      state.wizard.dataSite.cities.push(payload);
    },
    UPDATE_NEXT_BUTTON(state, payload) {
      state.wizard.bottomButtons.blockNext = payload;
    },
    UPDATE_SKIP(state, payload) {
      state.wizard.bottomButtons.showSkip = payload;
    },
    UPDATE_BOTTOM_BUTTONS(state, payload) {
      state.wizard.bottomButtons.showBottomButtons = payload;
    },
    UPDATE_COMPONENTS(state, payload) {
      state.wizard.components.splice(2, 20);
      let arr = Object.values(payload);
      for (let i = 0; i < arr.length; i++) {
        if (i >= 2) {
          state.wizard.components.push(arr[i]);
        }
      }
    },
    UPDATE_SLOGAN_HOME(state, payload) {
      state.wizard.dataSite.slogan = payload;
    },
    UPDATE_SUBSEGMENTS(state, payload) {
      state.wizard.subsegments = payload;
      state.wizard.dataSite.selectedSubsegments = [];
    },
    UPDATE_SUBSEGMENTS_REMOVE(state, payload) {
      state.wizard.dataSite.selectedSubsegments.splice(payload, 1);
    },
    UPDATE_SUBSEGMENTS_PAINEL_REMOVE(state, payload) {
      state.siteActive.segment.subSegments.splice(payload, 1);
    },
    UPDATE_SUBSEGMENTS_ADD(state, payload) {
      state.wizard.dataSite.selectedSubsegments.push(payload);
    },
    UPDATE_SUBSEGMENTS_PAINEL_ADD(state, payload) {
      state.siteActive.segment.subSegments.push(payload);
    },
    UPDATE_SUBSEGMENTS_CUSTOM(state, payload) {
      state.wizard.subsegments.push({
        id: null,
        description: payload
      });
      state.wizard.dataSite.selectedSubsegments.push({
        id: null,
        description: payload
      });
    },
    UPDATE_TESTIMONIES(state, payload) {
      if (state.wizard.dataSite.testimonies.length == 0) {
        state.wizard.dataSite.testimonies = payload;
      }
    },
    WIZARD_UPDATE_TESTIMONY(state, payload) {
      state.wizard.dataSite.testimonies[payload].save_comment = !state.wizard
        .dataSite.testimonies[payload].save_comment;
    },
    POPULATE_POSTS(state, payload) {
      state.wizard.dataSite.posts = payload;
      state.wizard.dataSite.novidades = payload;
    },
    POPULATE_ALL_IMAGES(state, payload) {
      state.wizard.dataSite.allImages = payload;
    },
    UPDATE_SEGMENT(state, payload) {
      state.wizard.dataSite.segment = payload;
    },
    UPDATE_SEGMENT_PAINEL(state, payload) {
      state.siteActive.segment.segment = payload;
    },
    WIZARD_ABOUT_ADD_PICTURE(state, payload) {
      payload.forEach(item => {
        state.wizard.dataSite.aboutSetup.images.push(item);
      });
    },
    WIZARD_ABOUT_REMOVE_PICTURE(state, payload) {
      state.wizard.dataSite.aboutSetup.images.splice(payload, 1);
    },
    WIZARD_CONTACT_ADD_PICTURE(state, payload) {
      payload.forEach(item => {
        state.wizard.dataSite.contactSetup.images.push(item);
      });
    },
    WIZARD_CONTACT_REMOVE_PICTURE(state, payload) {
      state.wizard.dataSite.contactSetup.images.splice(payload, 1);
    },
    WIZARD_UPDATE_TEMPLATE(state, payload) {
      state.wizard.dataSite.template = payload;
    },
    WIZARD_UPDATE_COLORSCHEMA(state, payload) {
      state.wizard.dataSite.customSchema = payload;
    },
    WIZARD_UPDATE_THEMEMODE(state, payload) {
      state.wizard.dataSite.themeMode = payload;
    },
    WIZARD_PROFILE_PICTURE_ADD(state, payload) {
      state.wizard.dataSite.profilePicture = payload;
    },
    WIZARD_UPDATE_SELECTED_LOGO(state, payload) {
      state.wizard.dataSite.logoSelected = payload;
    },
    WIZARD_UPDATE_SELECTED_ARTISTIC_NAME(state, payload) {
      state.wizard.dataSite.siteName = payload;
    },
    WIZARD_UPDATE_SELECTED_USERURL(state, payload) {
      state.wizard.dataSite.siteUrl = payload;
    },
    WIZARD_UPDATE_SELECTED_LIST_CITIES(state, payload) {
      state.wizard.dataSite.cities = payload;
    },
    WIZARD_UPDATE_LIST_LOGOS(state, payload) {
      state.wizard.dataSite.listLogo = payload;
    },
    WIZARD_UPDATE_LOGO_PICTURE(state, payload) {
      state.wizard.dataSite.logoPicture = payload;
    },
    WIZARD_UPDATE_AVATAR_PICTURE(state, payload) {
      state.wizard.dataSite.avatarPicture = payload;
    },
    WIZARD_SAVE_CREATED_ITEMS(state, payload) {
      if (
        state.wizard.dataSite.createdItems.some(e => e.page == payload.page)
      ) {
        let indexItem = state.wizard.dataSite.createdItems.findIndex(
          e => e.page == payload.page
        );
        state.wizard.dataSite.createdItems[indexItem] = payload;
      } else {
        state.wizard.dataSite.createdItems.push(payload);
      }
    },
    WIZARD_UPDATE_HIGHLIGHTS(state, payload) {
      state.wizard.dataSite.highlights = payload;
    },
    WIZARD_UPDATE_ABOUT_LIST(state, payload) {
      state.wizard.dataSite.aboutSetup.aboutList = payload;
    },
    WIZARD_UPTADE_ABOUT(state, payload) {
      state.wizard.dataSite.aboutSetup.selected = payload;
    },
    WIZARD_UPDATE_CONTACT(state, payload) {
      state.wizard.dataSite.contactSetup = payload;
    },
    WIZARD_PORTFOLIO_CREATE_CARDS(state) {
      state.wizard.dataSite.portfolio = [];
      state.wizard.dataSite.selectedSubsegments.forEach(element => {
        state.wizard.dataSite.portfolio.push({
          title: element.description,
          suggestions: [],
          contents: []
        });
      });
      state.wizard.dataSite.selectedSubsegments.forEach(element => {
        state.wizard.dataSite.servicos.push({
          title: element.description,
          suggestions: [],
          contents: []
        });
      });
    },
    WIZARD_PUSH_ABOUT_SOCIAL(state) {
      let social = state.wizard.segments[0].about[0];
      state.wizard.dataSite.aboutSetup.aboutList = [];
      state.wizard.dataSite.aboutSetup.aboutList.push(social);
    },
    COMPONENT_SAVE_MEDIA_MANAGER(state, payload) {
      state.mediaManager.loaded = true;
      state.mediaManager.medias = payload;
    },
    WIZARD_UPDATE_CONTENT_BLOG(state, payload) {
      state.wizard.dataSite.posts = payload;
    },
    WIZARD_UPDATE_CONTENT_NOVIDADES(state, payload) {
      state.wizard.dataSite.novidades = payload;
    },
    WIZARD_UPDATE_CONTENT_SERVICOS(state, payload) {
      state.wizard.dataSite.servicos = payload;
    },
    WIZARD_UPDATE_CONTENT_PORTFOLIO(state, payload) {
      state.wizard.dataSite.portfolio = payload;
    },
    WIZARD_TOGGLE_LOADING(state, payload) {
      state.wizard.loading = payload;
    },
    WIZARD_SAVE_START_DATE(state, payload) {
      state.wizard.dataSite.createTime.startTime = payload;
    },
    WIZARD_SAVE_END_DATE(state, payload) {
      state.wizard.dataSite.createTime.finishTime = payload;
    },
    PAINEL_CLEAR_SELECTEDS_SUBSEGMENTS(state) {
      state.siteActive.segment.subSegments = [];
    },
    WIZARD_CLEAR_SUBSEGMENTS(state) {
      state.wizard.subsegments = [];
    },
    TOGGLE_LAYOUT_PREVIEW(state) {
      state.wizard.layout.layoutPreview = !state.wizard.layout.layoutPreview;
    },
    CHANGE_IFRAME_MODE(state, payload) {
      state.wizard.layout.iframeMode = payload;
    },
    SELECT_LAYOUT(state, payload) {
      state.wizard.dataSite.layout = payload;
    },
    CLEAR_LAYOUT_SELECTED(state) {
      state.wizard.dataSite.layout = {
        id: null,
        url: "",
        thumbnail: ""
      };
    },
    COMPLETE_STEP(state, payload) {
      let index = state.wizard.components.findIndex(
        component => component.title == payload
      );
      state.wizard.components[index].dirt = true;
    }
  },
  actions: {
    WIZARD_SEND_WIZARD() {
      this.commit("SEND_WIZARD");
    },
    CLEAR_SUBSEGMENTS() {
      this.commit("WIZARD_CLEAR_SUBSEGMENTS");
    },
    CLEAR_SELECTEDS_SUBSEGMENTS() {
      this.commit("PAINEL_CLEAR_SELECTEDS_SUBSEGMENTS");
    },
    WIZARD_START_DATE() {
      const startDate = new Date();
      this.commit("WIZARD_SAVE_START_DATE", startDate);
    },
    TOGGLE_LOADING(context, [status]) {
      this.commit("WIZARD_TOGGLE_LOADING", status);
    },
    UPDATE_CONTENTS(context, [stepName, totalCards]) {
      if (stepName == "Blog") {
        this.commit("WIZARD_UPDATE_CONTENT_BLOG", totalCards);
      } else if (stepName == "Novidades") {
        this.commit("WIZARD_UPDATE_CONTENT_NOVIDADES", totalCards);
      } else if (stepName == "Serviços") {
        this.commit("WIZARD_UPDATE_CONTENT_SERVICOS", totalCards);
      } else if (stepName == "Portfolio") {
        this.commit("WIZARD_UPDATE_CONTENT_PORTFOLIO", totalCards);
      }
    },
    PUSH_ABOUT_SOCIAL() {
      this.commit("WIZARD_PUSH_ABOUT_SOCIAL");
    },
    PAGES_CREATE_CARDS() {
      this.commit("WIZARD_PORTFOLIO_CREATE_CARDS");
    },
    SAVE_MEDIAMANAGER(context, [medias]) {
      this.commit("COMPONENT_SAVE_MEDIA_MANAGER", medias);
    },
    UPDATE_CONTACT(context, [contactData]) {
      this.commit("WIZARD_UPDATE_CONTACT", contactData);
    },
    UPTADE_ABOUT(context, [aboutSelected]) {
      this.commit("WIZARD_UPTADE_ABOUT", aboutSelected);
    },
    UPDATE_ABOUT_LIST(context, [list]) {
      this.commit("WIZARD_UPDATE_ABOUT_LIST", list);
    },
    UPDATE_HIGHLIGHTS(context, [list]) {
      this.commit("WIZARD_UPDATE_HIGHLIGHTS", list);
    },
    SAVE_CREATED_ITEMS(context, [stepName, posts]) {
      let item = {
        page: stepName,
        posts: posts
      };
      this.commit("WIZARD_SAVE_CREATED_ITEMS", item);
    },
    UPDATE_COMMERCIAL_NAME(context, [artisticName, userUrl, listCities]) {
      this.commit("WIZARD_UPDATE_SELECTED_ARTISTIC_NAME", artisticName);
      this.commit("WIZARD_UPDATE_SELECTED_USERURL", userUrl);
      this.commit("WIZARD_UPDATE_SELECTED_LIST_CITIES", listCities);
    },
    SELECT_LOGO(context, [typeSelected, logoPicture, logoList]) {
      this.commit("WIZARD_UPDATE_SELECTED_LOGO", typeSelected);
      this.commit("WIZARD_UPDATE_LOGO_PICTURE", logoPicture);
      this.commit("WIZARD_UPDATE_LIST_LOGOS", logoList);
    },
    UPDATE_AVATAR_PICTURE(context, [avatarPicture]) {
      this.commit("WIZARD_UPDATE_AVATAR_PICTURE", avatarPicture);
    },
    GET_LOGOS() {
      let token = localStorage.getItem("jwt");
      axios({
        method: "get",
        url: `${process.env.ROOT_API}/api/logo`,
        data: "",
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(response => {
          this.commit("WIZARD_UPDATE_LIST_LOGOS", response.data.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    UPDATE_THEMEMODE(context, [content]) {
      this.commit("WIZARD_UPDATE_THEMEMODE", content);
    },
    UPDATE_TEMPLATE(context, [content]) {
      this.commit("WIZARD_UPDATE_TEMPLATE", content);
    },
    UPDATE_COLORSCHEMA(context, [content]) {
      this.commit("WIZARD_UPDATE_COLORSCHEMA", content);
    },
    CONTACT_ADD_PICTURE(context, [images]) {
      this.commit("WIZARD_CONTACT_ADD_PICTURE", images);
    },
    CONTACT_REMOVE_PICTURE(context, [index]) {
      this.commit("WIZARD_CONTACT_REMOVE_PICTURE", index);
    },
    ABOUT_ADD_PICTURE(context, [images]) {
      this.commit("WIZARD_ABOUT_ADD_PICTURE", images);
    },
    ABOUT_REMOVE_PICTURE(context, [index]) {
      this.commit("WIZARD_ABOUT_REMOVE_PICTURE", index);
    },
    UPDATE_TESTIMONIES(context, [index]) {
      this.commit("WIZARD_UPDATE_TESTIMONY", index);
    },
    WIZARD_UPDATE_TESTIMONIES(context, [testimonies]) {
      this.commit("UPDATE_TESTIMONIES", testimonies);
    },
    WIZARD_SAVE_MEDIAS({ commit, state }) {
      let token = localStorage.getItem("jwt");
      let siteId = localStorage.siteId;
      axios({
        method: "get",
        url: `${process.env.ROOT_API}/api/site/${siteId}/wizard?savemedia=true`,
        data: "",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(response => {
        this.commit("POPULATE_POSTS", response.data.posts.cards);
        this.commit("POPULATE_ALL_IMAGES", response.data.posts.allImages);
        this.commit(
          "COMPONENT_SAVE_MEDIA_MANAGER",
          response.data.posts.allImages
        );
        // this.commit("UPDATE_SEGMENTS", response.data.content);
      });
    },
    WIZARD_CUSTON_SUBSEGMENT(context, [value]) {
      this.commit("UPDATE_SUBSEGMENTS_CUSTOM", value);
    },
    ADD_SUBSEGMENT(context, [value]) {
      this.commit("UPDATE_SUBSEGMENTS_ADD", value);
    },
    ADD_SUBSEGMENT_PAINEL(context, [value]) {
      this.commit("UPDATE_SUBSEGMENTS_PAINEL_ADD", value);
    },
    REMOVE_SUBSEGMENT_PAINEL(context, [value]) {
      this.commit("UPDATE_SUBSEGMENTS_PAINEL_REMOVE", value);
    },
    REMOVE_SUBSEGMENT(context, [value]) {
      this.commit("UPDATE_SUBSEGMENTS_REMOVE", value);
    },
    WIZARD_BOTTOM_BUTTONS(context, [value]) {
      this.commit("UPDATE_BOTTOM_BUTTONS", value);
    },
    WIZARD_SHOW_SKIP(context, [status]) {
      this.commit("UPDATE_SKIP", status);
    },
    WIZARD_BLOCK_NEXT(context, [status]) {
      this.commit("UPDATE_NEXT_BUTTON", status);
    },
    WIZARD_CITY_ADD(context, [city]) {
      this.commit("UPDATE_CITY", city);
    },
    WIZARD_SUBSEGMENTS_REMOVE(context, [subsegment]) {
      this.commit("UPDATE_SUBSEGMENTS_REMOVE", subsegment);
    },
    WIZARD_SUBSEGMENTS_ADD(context, [subsegment]) {
      this.commit("UPDATE_SUBSEGMENTS_ADD", subsegment);
    },
    WIZARD_WHATSAPP_IDD(context, [data1]) {
      this.commit("UPDATE_WHATSAPP_IDD", data1);
    },
    WIZARD_WHATSAPP_NUMBER(context, [data1]) {
      this.commit("UPDATE_WHATSAPP_NUMBER", data1);
    },
    WIZARD_UPDATE_STEP(context, [index]) {
      this.commit("UPDATE_STEP", index);
    },
    WIZARD_UPDATE_COMPONENTS(context, [data1]) {
      this.commit("UPDATE_COMPONENTS", data1);
    },
    WIZARD_UPDATE_SEGMENT(context, [segment]) {
      this.commit("UPDATE_SEGMENT", segment);
    },
    PAINEL_UPDATE_SEGMENT(context, [segment]) {
      this.commit("UPDATE_SEGMENT_PAINEL", segment);
    },
    WIZARD_UPDATE_SUBSEGMENTS(context, [subSegments]) {
      this.commit("UPDATE_SUBSEGMENTS", subSegments);
    },
    WIZARD_UPDATE_SLOGAN_HOME(context, [slogan]) {
      this.commit("UPDATE_SLOGAN_HOME", slogan);
    },
    WIZARD_TOGGLE_LAYOUT_PREVIEW() {
      this.commit("TOGGLE_LAYOUT_PREVIEW");
    },
    WIZARD_CHANGE_IFRAME_MODE(context, [mode]) {
      this.commit("CHANGE_IFRAME_MODE", mode);
    },
    WIZARD_SELECT_LAYOUT(context, [layout]) {
      this.commit("SELECT_LAYOUT", layout);
    },
    WIZARD_CLEAR_LAYOUT_SELECTED() {
      this.commit("CLEAR_LAYOUT_SELECTED");
    },
    WIZARD_POPULATE_LAYOUTS(context, [layouts]) {
      this.commit("POPULATE_LAYOUTS", layouts);
    },
    WIZARD_COMPLETE_STEP(context, [stepName]) {
      this.commit("COMPLETE_STEP", stepName);
    },
    GET_SEGMENTS() {
      let token = localStorage.getItem("jwt");
      axios({
        method: "get",
        url: `${process.env.ROOT_API}/api/segment/search`,
        data: "",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(response => {
        this.commit("UPDATE_SEGMENTS", response.data.content);
      });
    },
    VERIFY_TOKEN({ state }) {
      let token = localStorage.getItem("jwt");
      axios({
        method: "get",
        url: process.env.ROOT_API + "api/token/read",
        headers: {
          Authorization: "Bearer " + token
          // 'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => {
          response => response.json();
          state.contact.tel = response.data.application.contact_phone;
          state.contact.email = response.data.application.contact_email;
          if (response.data.status == 1) {
            this.commit("UPDATE_APPLICATION", response.data.application);
            this.commit(
              "applicationModule/updateApplication",
              response.data.application
            );
            this.commit("UPDATE_FAVICON", response.data.application);
            this.commit("UPDATE_USER", response.data);
            this.commit("userModule/updateUser", response.data);
            this.commit(
              "dashboardModule/updateSiteLink",
              `https://${localStorage.siteData.url}`
            );
          }
        })
        .catch(response => {
          console.log(response.data);
        });
    },
    VERIFY_SITE() {
      let token = localStorage.getItem("jwt");
      const siteId = localStorage.siteId;
      const siteData = {};
      axios({
        method: "get",
        url: process.env.ROOT_API + "api/token/read",
        headers: {
          Authorization: "Bearer " + token
          // 'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => {
          response => response.json();
          const siteId = localStorage.siteId;
          const siteData = {};
          const vm = this;
          if (response.data.status == 1) {
            response.data.sites.forEach(site => {
              if (site.id == siteId) {
                vm.siteData = site;
              }
            });

            if (vm.siteData && vm.siteData.wizard == 1) {
              this.commit("UPDATE_SITE_ACTIVE", vm.siteData);
              this.commit("dashboardModule/updateSiteData", vm.siteData);
            }
          }
        })
        .catch(response => {
          console.log(response);
        });
    }
  },
  modules: {
    userModule: userModule,
    siteModule: siteModule,
    applicationModule: applicationModule,
    dashboardModule: dashboardModule
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js